<template>
  <div id="products-panel" style="height: 100%; display: flex; flex-direction: column;">
    <div class="search-bar">
      <h5 class="section-title  m-2">Products</h5>
      <input type="text" name="searchProducts" id="searchProducts" class="form-control-sm search-field"
             placeholder="Search by plu, barcode or name" @keyup.enter="searchProducts" @keyup="searchProducts"
             v-model="input">
    </div>
    <RecycleScroller
      ref="productsGrid"
      class="product-grid"
      :items="stockProducts"
      key-field="PLU"
      :item-size="desktopItemSize"
      :item-secondary-size="desktopItemSecondarySize"
      :grid-items="desktopGridItems"
      :buffer="500"
      @scroll.native="handleScroll">
      <template v-slot="{ item }">
        <div class="product-grid-cell">
          <DesktopProductItem :product="item" @click="addToSale(item)" />
        </div>
      </template>
    </RecycleScroller>
    <div class="scroll-controls" v-if="isScrollable">
      <button class="scroll-control" @click="scrollToTop">
        <font-awesome-icon :icon="['fas', 'chevron-up']" />
      </button>
      <button class="scroll-control" @click="scrollToBottom">
        <font-awesome-icon :icon="['fas', 'chevron-down']" />
      </button>
    </div>
    <div class="d-flex flex-row justify-content-between" >
      <div class="salesbtn w-100">
        <div class="button-row-top">
          <button class="btn btn-primary-lightning cash-button" :disabled="fastSaleDisabled"
                  @click="fastProcessTransaction('Cash')">
            <font-awesome-icon :icon="['fas', 'money-bill-wave']" class="button-icon"></font-awesome-icon>
            Cash
            <span v-if="showShortcuts && shortcuts.Cash" class="shortcut-badge">{{ shortcuts.Cash }}</span>
          </button>
          <button class="btn btn-primary-lightning card-button" :disabled="fastSaleDisabled"
                  @click="fastProcessTransaction('Card')">
            <font-awesome-icon :icon="['fas', 'credit-card']" class="button-icon"></font-awesome-icon>
            Card
            <span v-if="showShortcuts && shortcuts.Card" class="shortcut-badge">{{ shortcuts.Card }}</span>
          </button>
<!--          <button class="btn btn-primary-lightning split-button" :disabled="fastSaleDisabled" @click="goToSplitScreen">-->
<!--            <font-awesome-icon :icon="['fas', 'cut']" class="button-icon"></font-awesome-icon>-->
<!--            Split-->
<!--            <span v-if="showShortcuts && shortcuts.splitPay" class="shortcut-badge">{{ shortcuts.splitPay }}</span>-->
<!--          </button>-->
          <button class="btn kazang-button" :disabled="fastSaleDisabled || !isOnline" @click="kazangPayment">
            <img height="25px" src="@/assets/img/Kazang.png" alt="Kazang" style="margin-right:0px">
            Kazang
            <span v-if="showShortcuts && shortcuts.cgratePay" class="shortcut-badge">{{ shortcuts.cgratePay }}</span>
          </button>
        </div>
        <div class="amount-input-row">
          <div class="amount-input-group">
            <label for="fastSaleAmount">Total Given</label>
<!--            <span v-if="showShortcuts && amountShortcut" class="shortcut-badge amount-shortcut">{{ amountShortcut }}</span>-->
            <input class="form-control input-amount" id="fastSaleAmount" ref="fastSaleAmount"
                   oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '0');"
                   pattern="[+-]?([0-9]*[.])?[0-9]+" type="text" v-model="paidAmount"
                   :placeholder="$utils.formatMoney(grandTotal, 2, '.', ',', false)" @input="onAmountInput"
                   @keydown.enter.prevent="fastProcessTransaction('Cash')">
          </div>
        </div>
        <div class="cart-actions d-flex" style="gap: 5px">
          <button class="btn btn-secondary flex-fill"  :style="delivery"  @click="viewOpenTable">
            LOAD
            <span v-if="showShortcuts && shortcuts.LoadTable" class="shortcut-badge">{{ shortcuts.LoadTable }}</span>
          </button>
          <button class="btn btn-secondary flex-fill"  :style="saveColor" @click="saveTable">
            SAVE
            <span v-if="showShortcuts && shortcuts.SaveTable" class="shortcut-badge">{{ shortcuts.SaveTable }}</span>
          </button>
          <button class="btn btn-dark flex-fill" :style="delivery" @click="processDelivery">
            DELIVERY
          </button>
          <button class="btn btn-primary flex-fill" :disabled="disabled" :style="color" @click="process">
            PAY
            <span v-if="showShortcuts && shortcuts.Payment" class="shortcut-badge">{{ shortcuts.Payment }}</span>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import DesktopProductItem from "@/components/point-of-sale/sales/pos/DesktopProductItem.vue";
import StockSearchBar from "@/components/point-of-sale/stock-search/StockSearchBar.vue";
import ProductItem from "@/components/point-of-sale/sales/pos/ProductItem.vue";
import ShoppingCart from "@/components/point-of-sale/sales/pos/ShoppingCart.vue";
import SaleDetails from "@/components/point-of-sale/sales/SaleDetails.vue";
import scaleService from '@/services/scaleService';
import connectivityMonitor from '@/services/connectivityMonitor';

export default {
  name: 'SearchedProducts',
  components: {SaleDetails, ShoppingCart, ProductItem, StockSearchBar,DesktopProductItem },
  computed: {
    curUser() {
      return this.$store.getters.getCurrentUser
    },
    showSearchBar() {
      return this.$store.getters.getShowSearchBar;
    },
    itemsInCart() {
      return this.$store.getters.getSaleLines.length
    },
    stockProducts() {
      return this.$store.getters.getActiveStockProducts || [];
    },
    categorySearch() {
      return this.$store.getters.getSearchCategories
    },
    currentSale() {
      return this.$store.getters.getCurrentSale
    },
    saleTotal() {
      const total = Number(this.$store.getters.getSaleTotal);
      const tips = Number(this.$store.getters.getTipAmount);
      return (Number.isFinite(total) ? total : 0) + (Number.isFinite(tips) ? tips : 0);
    },
    discountTotal() {
      const discount = this.$store.getters.getSaleDiscount;
      const total = Number(discount?.total ?? discount ?? 0);
      return Number.isFinite(total) ? total : 0;
    },
    grandTotal() {
      const required = Number((this.saleTotal - this.discountTotal).toFixed(2));
      return required < 0 ? 0 : required;
    },
    disabled() {
      return this.saleTotal <= 0;
    },
    color() {
      return this.disabled ? {background: 'grey'} : {background: '#9ccc65'}
    },

    delivery() {
      return this.disabled ? {background: 'grey'} : {background: '#37b1c6'}
    },

    saveColor() {
      return this.disabled ? {background: 'grey'} : {background: '#475f9b'}
    },
    currentSaleLines() {
      return this.$store.getters.getSaleLines || [];
    },
    fastSaleDisabled() {
      if (this.currentSaleLines.length === 0) return true;
      if (this.loading) return true;
      if (this.insufficientAmount) return true;
      return false;
    },
    insufficientAmount() {
      const val = parseFloat(this.paidAmount);
      if (!Number.isFinite(val)) return false;
      const normalized = Number(val.toFixed(2));
      if (normalized <= 0) return false;
      return this.grandTotal > 0 && normalized < this.grandTotal;
    },
    shortcuts() {
      return this.$store.getters.getShortcuts || {};
    },
    isAndroid() { return window.androidMode; },
    showShortcuts() { return !this.isAndroid; },
    amountShortcut() {
      const sc = this.shortcuts || {};
      return sc.TotalGiven || sc.FocusAmount || sc.Payment || '';
    },
  },
  created() {
    // Load saved sale lines when component is created
    this.$store.dispatch("loadFromLocalStorage");
  },
  watch: {
    paidAmount: {
      handler() {
        this.setAmount();
      }
    },
    grandTotal(newVal) {
      const shouldSync = !this.isAmountDirty ||
          this.paidAmount === "" ||
          this.paidAmount === null ||
          this.paidAmount === undefined ||
          Number(this.paidAmount) === 0;

      if (Number.isFinite(newVal) && shouldSync) {
        this.paidAmount = Number(newVal).toFixed(2);
      }
    }
  },
  data() {
    return {
      input: '',
      timer: undefined,
      isScrollable: false,
      scrollPosition: 0,
      maxScrollTop: 0,
      paidAmount: "",
      isAmountDirty: false,
      loading: false,
      reference: "",
      isOnline: true,
      unsubscribeOnline: null,
      unsubscribeOffline: null,
      desktopGridItems: 5,
      desktopItemSize: 132,
      desktopItemSecondarySize: 128,
    }
  },
  mounted() {
    const init = Number(this.grandTotal);
    this.paidAmount = Number.isFinite(init) ? init.toFixed(2) : "";
    this.isAmountDirty = false;

    this.isOnline = connectivityMonitor.getStatus();
    this.unsubscribeOnline = connectivityMonitor.subscribe('online', () => {
      this.isOnline = true;
    });
    this.unsubscribeOffline = connectivityMonitor.subscribe('offline', () => {
      this.isOnline = false;
    });

    this.$nextTick(() => {
      this.updateGridMetrics();
      this.handleScroll();
    });
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.unsubscribeOnline) {
      this.unsubscribeOnline();
    }
    if (this.unsubscribeOffline) {
      this.unsubscribeOffline();
    }
  },
  methods: {
    getProductsScrollElement() {
      const ref = this.$refs.productsGrid;
      if (!ref) return null;
      return ref.$el || ref;
    },
    handleResize() {
      this.updateGridMetrics();
    },
    updateGridMetrics() {
      const gridEl = this.getProductsScrollElement();
      const panelWidth = Number(
        gridEl?.clientWidth ||
        this.$el?.clientWidth ||
        window.innerWidth ||
        1200
      );

      // Use actual panel width (not viewport width) so cards never exceed cell width.
      const usableWidth = Math.max(320, panelWidth - 12);
      const minCellWidth = 132;
      const maxItems = 9;
      const minItems = 2;
      const computedItems = Math.floor(usableWidth / minCellWidth);

      this.desktopGridItems = Math.max(minItems, Math.min(maxItems, computedItems || minItems));

      const computedCellWidth = Math.floor(usableWidth / this.desktopGridItems);
      this.desktopItemSecondarySize = Math.max(92, Math.min(128, computedCellWidth - 8));
    },
    async saveTable() {
      let close = document.getElementById(`canvasClose`);
      if (close) close.click();
      const routeSaleNumber = Number(this.$route?.query?.saleNumber || 0);
      const tables = this.$store.getters.getAllTables || [];
      let effectiveSale = Number(this.currentSale || 0);

      // Recover table context from route when state was reset unexpectedly.
      if ((!Number.isFinite(effectiveSale) || effectiveSale <= 0) && Number.isFinite(routeSaleNumber) && routeSaleNumber > 0) {
        effectiveSale = routeSaleNumber;
        this.$store.commit('setCurrentSale', routeSaleNumber);
        const matched = Array.isArray(tables)
          ? tables.find(t => Number(t?.saleNumber || t?.SaleNum || 0) === routeSaleNumber)
          : null;
        if (matched) {
          const recoveredName = String(matched?.Name || matched?.name || '').trim();
          if (recoveredName) {
            this.$store.commit('setOpenTableName', recoveredName);
          }
        }
      }

      if (!Number.isFinite(effectiveSale) || effectiveSale <= 0) {
        return this.createTable();
      }

      const openTableName = (this.$store.getters.getOpenTableName || '').trim();
      const hasExplicitOpenTable = !!openTableName || (Number.isFinite(routeSaleNumber) && routeSaleNumber > 0);
      if (!hasExplicitOpenTable) {
        return this.createTable();
      }

      if (!openTableName) {
        try {
          const exists = Array.isArray(tables) && tables.some(t => {
            const sn = Number(t?.saleNumber || t?.SaleNum || 0);
            return sn > 0 && sn === Number(effectiveSale);
          });
          if (!exists) {
            return this.createTable();
          }
        } catch (e) { }
      }

      return this.editTable();
    },
    // Simple method to update table without showing messages.
    // The backend requires the authenticated cashier to be present in the
    // payload (see AddOrUpdateTable in table-module.js) — without it, the
    // POST to /OnlineSalesServer/tables/{storeDb} returns
    // 400 "user account not detected". We attach `user` here so the contract
    // is clean at the source, and the action also re-attaches it as a
    // belt-and-braces guard.
    updateTable() {
      let table = {};
      const routeSaleNumber = Number(this.$route?.query?.saleNumber || 0);
      table.items = this.$store.getters.getSaleLines;
      table.Customer = this.$store.getters.getCustomer;
      table.name = this.$store.getters.getOpenTableName;
      table.SaleNum = Number(this.currentSale || routeSaleNumber || 0);
      try {
        const u = this.$store.getters.getCurrentUser;
        if (u && (u.Username || u.username)) {
          table.user = u.Username || u.username;
        }
      } catch (_) { /* no-op: user getter may be unavailable mid-mount */ }
      return this.$store.dispatch('AddOrUpdateTable', table);
    },
    loadPanel() {
      return Swal.fire({
        html: 'Updating table....',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading()
        },
      });
    },
    editTable(navigateTo = 'tables') {
      let settings = this.$store.getters.getDeviceSettings;
      let table = {};
      const routeSaleNumber = Number(this.$route?.query?.saleNumber || 0);
      this.loadPanel()
      table.items = this.$store.getters.getSaleLines;
      table.Customer = this.$store.getters.getCustomer;
      table.name = this.$store.getters.getOpenTableName;
      table.SaleNum = Number(this.currentSale || routeSaleNumber || 0);
      // PAY and DELIVERY route the cashier to the payment screen, so the cart
      // must remain intact for them to charge. LOAD / SAVE navigate to the
      // tables list afterwards and want the cart cleared. keepCart is read by
      // the Vuex action 'updateTable' (see table-module.js updateTable).
      table.keepCart = navigateTo !== 'tables';
      // RESTAURANT-POS-Q: track soft-skip so finally does not clear cart while first save runs
      let skippedDuplicate = false;
      return this.$store.dispatch('updateTable', table)
          .then((result) => {
            // Concurrent save soft-skipped — stay put; no success toast/navigation
            if (result && result.skipped) {
              skippedDuplicate = true;
              return;
            }
            responses.showInfo('Table successfully updated')
            let autoLogout = settings.AutoLog === 1;
            if (autoLogout) {
              return this.$router.push({name: `poslogin`});
            }
            return this.$router.push({name: navigateTo})
          }).finally(() => {
            // Only clear local cache after a real successful save, not a soft-skip
            if (!skippedDuplicate) {
              this.$store.dispatch("clearLocalStorage")
            }
            Swal.close()
          })
    },
    createTable() {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        title: 'Table Name',
        icon: 'question',
        input: 'text',
        showCancelButton: true,
        confirmButtonText: 'Save Table',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Table name is required`);
          // Do NOT wipe currentSale here. After a failed invoice, parseInvoice may
          // already have reserved a saleNumber — Save-for-later must reuse it
          // (name prompt only). Wiping forced a second mint via AddOrUpdateTable.
          // docs: FRONTEND.md — invoice fail → Save-for-later reuses saleNumber
          this.$store.commit(`setOpenTableName`, input)
          return this.$store.dispatch('saveNewTable', {
            name: input,
            Customer: this.$store.getters.getCustomer,
          }).then((saveResult) => {
            // RESTAURANT-POS-Q: soft-skip keeps dialog open with wait message
            if (saveResult && saveResult.skipped) {
              return Swal.showValidationMessage('Save already in progress, please wait');
            }
            return input;
          })
              .catch(error => Swal.showValidationMessage(error))
        },
      }).then((result) => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return Swal.fire({
            title: `Success`,
            icon: 'success',
            text: `Table ${result.value} Saved`
          }).then(() => {
            this.$store.commit('setOpenTableName', '')
            this.$store.commit('setCurrentSale', 0)
            this.$store.dispatch("clearLocalStorage")
            return this.$store.dispatch(`proceedToSales`)
          })
        }
      })
    },
    /**
     * PAY button handler. Routes the cashier to the `payment` screen.
     * If an open table is in use, persists pending items to that table
     * first via the SAME code path that LOAD/SAVE use (editTable) so the
     * sale survives the navigation. `navigateTo: 'payment'` tells editTable
     * to keep the cart intact and route to the payment screen instead of
     * the tables list. Does NOT mutate tip/discount/customer.
     *
     * DELIVERY calls this after zeroing the tip (see processDelivery).
     *
     * @returns {Promise} resolves when navigation has been triggered.
     */
    process() {
      // Save the open table (if any) using the same flow LOAD/SAVE already
      // use, then route to payment. This produces the rich payload the
      // backend expects (User, PC, server, orderNumber, isUpdate, etc.) and
      // keeps the cart intact for the payment screen.
      const openTableName = this.$store.getters.getOpenTableName;
      if (openTableName) {
        return this.editTable('payment');
      }
      return this.$router.push({name: 'payment'})
    },
    /**
     * "Delivery" click handler in the products panel.
     *
     * Intended behaviour: only the tip should be cleared. Cart lines,
     * sale number, discount, customer and table must remain so the
     * delivery payment can still be processed.
     *
     * Current behaviour: only `setTipAmount(0)` is committed before
     * delegating to `process()` which (a) updates the open table if
     * one exists and (b) navigates to the `payment` route. No cart,
     * discount, customer, sale number or table clearing happens in
     * this method.
     *
     * NOTE — investigation 2026-07-23 (Athena): If Felix perceives
     * that MORE than the tip is cleared when Delivery is clicked,
     * the extra clearing is NOT in this handler. Likely culprits:
     *   - `PaymenScreen.vue#back()` (~line 463) dispatches
     *     `calculateTipAmount` (which re-derives tip from AutoTip%)
     *     and commits `clearDiscount` when leaving payment.
     *   - `sales-module.js#clearSale` mutation (~line 1047) wipes
     *     saleLines, currentSale, saleDiscount, tip, openTableName.
     *   - `sales-module.js#processTransaction` (~line 2101) clears
     *     tip + sale + discount + lines + table on successful pay.
     */
    processDelivery() {
      this.$store.commit(`setTipAmount`, 0)
      return this.process();
    },
    focusTotalGiven() {
      if (!this.paidAmount) {
        this.paidAmount = Number(this.grandTotal).toFixed(2);
      }
      this.$nextTick(() => {
        const el = this.$refs.fastSaleAmount;
        if (el && typeof el.focus === 'function') {
          el.focus();
          if (typeof el.select === 'function') {
            el.select();
          }
        }
      });
    },
    checkPaidAmount() {
      if (this.paidAmount === "" || this.paidAmount === null || this.paidAmount === undefined) {
        return Number(this.grandTotal);
      }
      let paid = parseFloat(this.paidAmount);
      if (!Number.isFinite(paid)) paid = 0;
      return Number(paid.toFixed(2));
    },
    setAmount() {
      const val = this.paidAmount;
      if (val !== "" && val !== null && val !== undefined) {
        const n = parseFloat(val);
        if (Number.isFinite(n) && Number(n.toFixed(2)) === 0) {
          const total = Number(this.grandTotal);
          this.paidAmount = total > 0 ? total.toFixed(2) : "0";
        }
      }
    },
    onAmountInput() {
      const val = this.paidAmount;
      this.isAmountDirty = !(val === "" || val === null || val === undefined);
    },
    async openCashDrawer() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `OpenDrwer`);
      if (isAllowed) return this.$store.dispatch(`openCashDrawer`)
    },
    async fastProcessTransaction(type) {
      // Update table if there's an open table with new items
      const openTableName = this.$store.getters.getOpenTableName;
      if (openTableName) {
        await this.updateTable();
      }

      const requiredTotal = Number(this.grandTotal);
      let paidInput = parseFloat(this.checkPaidAmount());
      if (!Number.isFinite(paidInput)) paidInput = 0;
      paidInput = Number(paidInput.toFixed(2));

      if (requiredTotal > 0 && paidInput < requiredTotal) {
        await Swal.fire({
          icon: 'warning',
          title: 'Insufficient Amount',
          html: `The total given (${this.$utils.formatMoney(paidInput, 2, '.', ',', true)}) is less than the sale total (${this.$utils.formatMoney(requiredTotal, 2, '.', ',', true)}).`,
          confirmButtonColor: 'var(--danger)'
        });
        return;
      }

      this.openCashDrawer();
      this.loading = true;
      this.$utils.showLoading();

      this.$store.commit('setSaleDetails', {
        refund: false,
        reference: this.reference,
        total: parseFloat(this.saleTotal.toFixed(2)),
        paid: paidInput,
        change: parseFloat(Number(paidInput - requiredTotal).toFixed(2))
      });

      let obj = this.$store.getters.getSaleDetails || {};
      obj.type = type;

      try {
        await this.$store.dispatch("processTransaction", {
          ...obj,
          refund: false,
          reference: this.reference,
          total: parseFloat(this.saleTotal.toFixed(2)),
          paid: paidInput,
          change: parseFloat(Number(paidInput - requiredTotal).toFixed(2))
        });
      } catch (error) {
        console.error("Error processing transaction:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Transaction Failed',
          text: error?.message || 'Error processing transaction.'
        });
      } finally {
        this.paidAmount = "";
        this.isAmountDirty = false;
        this.loading = false;
        this.$utils.hideLoading();
      }
    },
    goToSplitScreen() {
      let obj = this.$store.getters.getSaleDetails || {};
      obj.type = 'Split';
      this.$store.commit('setSaleDetails', obj);
      return this.$router.push({name: 'split-payment'});
    },
    kazangPayment() {
      // Update table if there's an open table with new items
      const openTableName = this.$store.getters.getOpenTableName;
      if (openTableName) {
        this.updateTable();
      }

      this.openCashDrawer();
      this.$store.commit('setSaleDetails', {
        refund: false,
        reference: this.reference,
        total: parseFloat(this.saleTotal.toFixed(2)),
        paid: 0,
        change: 0
      });

      Swal.fire({
        title: 'Customer Phone No. ?',
        icon: 'question',
        input: 'tel',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Customer Phone No.`);
          return this.$store.dispatch('firstKazangPaymentStep', input)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
                else return res;
              }).catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push({name: 'viewPayment'})
        }
      })
    },
    searchProducts() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.$utils.hideLoading()
      }
      this.timer = setTimeout(() => {
        this.$utils.showLoading()
        let cat = this.categorySearch

        const query = {
          description: this.input,
          category: cat.category || '',
          subCategory: cat.subCategory || '',
          sub2Category: cat.sub2Category || ''
        }
        return this.$store.dispatch('searchDescription', query)
            .finally(() => this.$utils.hideLoading())
      }, 300)
    },
    viewOpenTable() {
        const existingTableName = (this.$store.getters.getOpenTableName || '').trim();
        if (this.itemsInCart > 0) {
          if (existingTableName) {
            return this.editTable();
          }
          return this.createTable();
        }
        return this.$router.push({ name: 'tables' })
    },
    viewShoppingCart() {
    },
    async addToSale(item) {
      try {
        const defaultSetting = {
          plu: String(item?.PLU || ''),
          cookingLink: false,
          mtv: 0,
          printer: null,
          askForPrice: false,
          askForDescription: false,
          askForBoth: false,
          NonStock: false,
          tourism: false,
          getQtyFromPrice: false,
          password_protected: false,
          scale: false
        };
        const getByPlu = this.$store.getters.getStockSettingByPlu;
        const cachedSetting = typeof getByPlu === 'function' ? getByPlu(item.PLU) : null;
        const set = cachedSetting || await this.$store.dispatch('getStockSetting', item.PLU) || defaultSetting;

        let cost = Number(item?.InclCost);
        if (!Number.isFinite(cost)) cost = 0;
        cost = Number(cost.toFixed(2));
        let price = Number(item?.SellingIncl);
        if (!Number.isFinite(price)) price = 0;
        price = Number(price.toFixed(2));
        let description = item.Description;
        const defaultSellingPrice = Number(item?.SellingIncl || 0);
        let hasManualPriceOverride = false;
        let quantity = 1;

        const isFastPath = Boolean(cachedSetting)
          && !set.getQtyFromPrice
          && !set.scale
          && !set.askForDescription
          && !set.askForBoth
          && !set.askForPrice
          && !set.cookingLink
          && !set.tourism
          && !(cost > price);

        if (isFastPath) {
          let specialPrice = this.$store.getters.getItemSpecialPrice(item.PLU);
          if (specialPrice) {
            responses.showSuccess(`Special Detected`);
            price = Number(specialPrice);
          }
          let obj = {
            Plu: item.PLU,
            Description: description,
            Qty: 1,
            Unit: price,
            Line: price,
            baseUnit: Number(defaultSellingPrice.toFixed(2)),
            tourismLevy: 0,
            Discount: 0,
            vat: 0,
            instructions: []
          }
          this.$store.commit('addToCurrentSaleLines', obj);
          this.$store.dispatch('calculateTipAmount');
          return;
        }

        if (set.getQtyFromPrice) {
          const { value: totalItemPrice } = await Swal.fire({
            title: 'Enter Total Item Price',
            input: 'number',
            icon : "question",
            inputLabel: 'Total Item Price',
            inputPlaceholder: 'Enter the total price for the items',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputValidator: (value) => {
              if (!value || isNaN(value) || value <= 0) {
                return 'Please enter a valid price!';
              }
            }
          });

          if (totalItemPrice) {
            quantity = totalItemPrice / price;
          }
        }

        // Check for scale item
        if (set.scale) {
          const weight = await this.askForWeight(item);
          if (!weight) return; // User cancelled
          quantity = weight;
        }

        if (cost > price) {
          const result = await Swal.fire({
            allowOutsideClick: false,
            icon: "warning",
            showCancelButton: true,
            showLoaderOnConfirm: true,
            title: `Cost price is greater than Selling price`,
            confirmButtonText: 'Proceed',
            focusConfirm: false,
          });

          if (!result.isConfirmed) {
            return;
          }
        }

        if (set.askForDescription || set.askForBoth) {
          description = (await this.askForDescription(item));
        }

        if (set.askForPrice || set.askForBoth) {
          const enteredPrice = Number(await this.askForPrice(item));
          if (Number.isFinite(enteredPrice)) {
            price = Number(enteredPrice.toFixed(2));
            hasManualPriceOverride = price !== Number(defaultSellingPrice.toFixed(2));
          }
        }

        let tourismLevy = 0.0;
        if (set.tourism){
          let obj = { amount : price, incl : true }
          tourismLevy = await this.$store.dispatch('getTourismLevyAmount', obj);
        }

        if (set.cookingLink) {
          this.$emit('open-instruction', item, set.cookingLink);
          return;
        }
        let specialPrice = this.$store.getters.getItemSpecialPrice(item.PLU)
        if (!hasManualPriceOverride && specialPrice) {
          responses.showSuccess(`Special Detected`)
          price = Number(specialPrice);
        }
        let obj = {
          Plu: item.PLU,
          Description: description,
          Qty: quantity,
          Unit: price,
          Line: price,
          // Preserve cashier-entered price as the base price to prevent recalc from resetting it.
          baseUnit: hasManualPriceOverride ? Number(price) : Number(defaultSellingPrice.toFixed(2)),
          tourismLevy,
          Discount: 0,
          vat: 0,
          instructions: []
        }
        this.$store.commit('addToCurrentSaleLines', obj);
        return this.$store.dispatch(`calculateTipAmount`)
      } catch (err) {
        console.error('[SearchedProducts] Failed to add to sale:', err);
        responses.showError('Failed to add item');
      }
    },
    askForPrice(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Selling Price`,
        html: `<h6 >Description : ${item.Description}</h6>
               <h6 >Current Price : ${$utils.formatMoney(item.SellingIncl)}</h6>
               <input type="number" step="0.01" id="selling-prc" class="swal2-input" placeholder="Selling Price" style="max-width: 70%">`,
        confirmButtonText: 'Set Price',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#selling-prc').value;
          if (!value) {
            Swal.showValidationMessage(`Please enter a valid Selling Price`)
          }
          return parseFloat(value);
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        return parseFloat(item.SellingIncl.toFixed(2))
      })
    },
    askForDescription(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Description`,
        html: `<h6 >Description : ${item.Description}</h6>
               <textarea id="desc-ask" class="swal2-input" placeholder="Description" style="max-width: 70%">`,
        confirmButtonText: 'Set Description',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#desc-ask').value
          if (!value || value.toString().trim() === "") {
            Swal.showValidationMessage(`Please enter a valid Description`)
          }
          return value;
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        return item.Description
      })
    },
    async askForWeight(item) {
      const $utils = this.$utils;
      const unitPrice = item.SellingIncl || item.Unit || 0;
      const canManualWeightEntry = await this.$store.dispatch('validateSecurityPermissionNoPrompt', 'manualWeightEntry');
      this.$store.commit('setIsTabOpen', true);

      return Swal.fire({
        title: 'Enter Weight',
        html: `
          <div style="text-align: left; margin-bottom: 16px;">
            <p style="margin: 4px 0;"><strong>Item:</strong> ${item.Description}</p>
            <p style="margin: 4px 0;"><strong>Price per ${item.SalesUnitOfMeasure || 'kg'}:</strong> ${$utils.formatMoney(unitPrice)}</p>
            ${canManualWeightEntry ? '' : '<p id="manual-weight-note" style="margin: 8px 0 0; color: #d97706; font-weight: 600;">Manual weight entry is disabled for your account. Use Read Scale to fill the weight.</p>'}
          </div>
          <input type="number" id="weight-input" class="swal2-input" placeholder="Enter weight (kg)" step="0.001" ${canManualWeightEntry ? '' : 'readonly'} style="margin: 12px 0; background: var(--card-bg) !important; border: 2px solid var(--card-border) !important; color: var(--text-primary) !important; border-radius: 8px !important; height: 45px !important; padding: 0 16px !important; font-size: 16px !important;">
          <button id="read-scale-btn" class="swal2-confirm swal2-styled" style="margin-top: 12px; background: var(--accent-electric-blue); border: none; border-radius: 8px;">
            <i class="fa fa-balance-scale"></i> Read Scale
          </button>
          <div style="margin-top: 16px;">
            <strong style="font-size: 18px; color: var(--text-primary);">Total:</strong>
            <span id="total-price-display" style="font-size: 20px; font-weight: bold; color: var(--accent-electric-blue); margin-left: 12px;">
              ${$utils.formatMoney(0)}
            </span>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        didOpen: () => {
          const readBtn = Swal.getPopup().querySelector('#read-scale-btn');
          const input = Swal.getPopup().querySelector('#weight-input');
          const totalDisplay = Swal.getPopup().querySelector('#total-price-display');
          const note = Swal.getPopup().querySelector('#manual-weight-note');

          if (!canManualWeightEntry && input) {
            input.readOnly = true;
            input.placeholder = 'Manual entry disabled - use Read Scale';
            if (note) {
              note.scrollIntoView({ block: 'nearest' });
            }
          }

          const getScaleUnitSetting = () => {
            let unit = 'kg';
            let unitFromLocal = false;

            try {
              const localSettings = localStorage.getItem('local_scale_settings');
              if (localSettings) {
                const config = JSON.parse(localSettings);
                if (config.ScaleUnit) {
                  unit = config.ScaleUnit;
                  unitFromLocal = true;
                }
              }
            } catch (e) {
              console.warn('Failed to read local scale unit setting', e);
            }

            if (!unitFromLocal) {
              const deviceSettings = this.$store.getters.getDeviceSettings || {};
              if (deviceSettings.ScaleUnit) unit = deviceSettings.ScaleUnit;
            }

            return unit;
          };

          const updatePrice = () => {
            const weight = parseFloat(input.value) || 0;
            const total = (weight * unitPrice);
            totalDisplay.textContent = $utils.formatMoney(total);
          };

          if (input) {
            input.focus();
            input.addEventListener('input', updatePrice);
          }

          if (readBtn) {
            readBtn.addEventListener('click', async () => {
              const originalText = readBtn.innerHTML;
              readBtn.disabled = true;
              readBtn.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Reading...';

              try {
                let port = '';
                let baud = 9600;
                let dataBits = 8;
                let parity = 'none';
                let scaleModel = 'standard';
                let scaleDecimal = 3;

                try {
                  const localSettings = localStorage.getItem('local_scale_settings');
                  if (localSettings) {
                    const config = JSON.parse(localSettings);
                    if (config.ScalePort) port = config.ScalePort;
                    if (config.ScaleBaud) baud = parseInt(config.ScaleBaud);
                    if (config.ScaleDataBits) dataBits = parseInt(config.ScaleDataBits);
                    if (config.ScaleParity) parity = config.ScaleParity;
                    if (config.ScaleModel) scaleModel = config.ScaleModel;
                    if (config.ScaleDecimal) scaleDecimal = parseInt(config.ScaleDecimal);
                  }
                } catch (e) {
                  console.error('Error loading local scale settings:', e);
                }

                const deviceSettings = this.$store.getters.getDeviceSettings || {};
                if (!port && deviceSettings.ScalePort) port = deviceSettings.ScalePort;
                if (!baud && deviceSettings.ScaleBaud) baud = parseInt(deviceSettings.ScaleBaud);
                if (!dataBits && deviceSettings.ScaleDataBits) dataBits = parseInt(deviceSettings.ScaleDataBits);
                if (!parity && deviceSettings.ScaleParity) parity = deviceSettings.ScaleParity;
                if (!scaleModel && deviceSettings.ScaleModel) scaleModel = deviceSettings.ScaleModel;
                if (!scaleDecimal && deviceSettings.ScaleDecimal) scaleDecimal = parseInt(deviceSettings.ScaleDecimal);

                const connRes = await scaleService.connect(
                  port || 'COM2',
                  baud,
                  dataBits,
                  parity,
                  1,
                  scaleModel,
                  scaleDecimal
                );

                if (!connRes.ok && connRes.error !== 'Port already open') {
                  Swal.showValidationMessage('Failed to connect: ' + connRes.error);
                  return;
                }

                const res = await scaleService.readWeight();
                await scaleService.disconnect();

                if (res.ok) {
                  const scaleUnit = getScaleUnitSetting();
                  let weight = parseFloat(res.weight);

                  if (scaleUnit === 'g') {
                    weight = weight / 1000;
                  }

                  input.value = weight;
                  updatePrice();
                } else {
                  Swal.showValidationMessage('Error reading scale: ' + res.error);
                }
              } catch (err) {
                console.error('Scale read error:', err);
                Swal.showValidationMessage('Error: ' + err.message);
              } finally {
                readBtn.disabled = false;
                readBtn.innerHTML = originalText;
              }
            });
          }
        },
        preConfirm: () => {
          const val = Swal.getPopup().querySelector('#weight-input').value;
          if (!val || parseFloat(val) <= 0) {
            Swal.showValidationMessage('Please enter a valid weight');
            return false;
          }
          return parseFloat(val);
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false);
        if (result.isConfirmed) {
          return result.value;
        }
        return null;
      });
    },
    scrollToTop() {
      const el = this.getProductsScrollElement();
      if (!el || typeof el.scrollTo !== 'function') return;
      const newScrollTop = Math.max(this.scrollPosition - 110, 0);
      el.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    },
    scrollToBottom() {
      const el = this.getProductsScrollElement();
      if (!el || typeof el.scrollTo !== 'function') return;
      const newScrollTop = Math.min(this.scrollPosition + 110, this.maxScrollTop);
      el.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    },
    handleScroll() {
      const el = this.getProductsScrollElement();
      if (!el) return;
      const scroll = {
        scrollTop: el.scrollTop,
        scrollHeight: el.scrollHeight,
        clientHeight: el.clientHeight
      }
      this.scrollPosition = scroll.scrollTop
      this.maxScrollTop = scroll.scrollHeight - scroll.clientHeight
      this.isScrollable = scroll.scrollHeight > scroll.clientHeight;
    },
  }
}
</script>

<style lang="scss" scoped>
.offcanvas {
  padding: 0;

  .offcanvas-body {
    padding: 0 !important;
    position: relative;
  }
}

#products-panel {
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;


  .search-bar {
    display: flex;
    flex-direction: row;
    gap: 5px;
    padding: 3px;
    background: linear-gradient(135deg, rgba(var(--accent-primary-rgb), 0.04) 0%, rgba(var(--accent-primary-rgb), 0.02) 100%);
    border-bottom: var(--card-border);

    .search-field {
      width: 100%;
      border: 2px solid var(--card-border);
      border-radius: 12px;
      background-color: var(--card-bg);
      color: var(--text-primary);
      padding: 12px 16px;
      font-size: 15px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: var(--card-shadow);
      
      &:focus {
        border-color: var(--accent-primary);
        box-shadow: 0 0 0 4px rgba(var(--accent-primary-rgb), 0.15), var(--card-shadow);
        outline: none;
        transform: translateY(-1px);
      }
      
      &::placeholder {
        color: var(--text-secondary);
      }
    }

    .view-cart-btn {
      background: linear-gradient(135deg, var(--accent-primary) 0%, #2980b9 100%);
      color: white;
      border-radius: 12px;
      padding: 12px 20px;
      border: none;
      box-shadow: 0 4px 12px rgba(var(--accent-primary-rgb), 0.3);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      font-weight: 600;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(var(--accent-primary-rgb), 0.4);
      }
      
      &:active {
        transform: translateY(0);
      }

      .cart-count {
        position: absolute;
        top: -8px;
        right: -8px;
        color: white;
        background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
        border-radius: 50%;
        padding: 4px 8px;
        font-size: 0.7rem;
        font-weight: 700;
        box-shadow: 0 2px 8px rgba(231, 76, 60, 0.4);
      }
    }
  }

  .product-grid {
    overflow-y: auto;
    overflow-x: hidden;
    padding: 16px;
    background-color: transparent;
    
    // Custom scrollbar
    &::-webkit-scrollbar {
      width: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: var(--secondary-button-bg);
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: rgba(var(--accent-primary-rgb), 0.3);
      border-radius: 4px;
      
      &:hover {
        background: rgba(var(--accent-primary-rgb), 0.5);
      }
    }
  }

  .product-grid-cell {
    display: flex;
    justify-content: center;
    padding: 2px 4px;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  // vue-virtual-scroller defaults to overflow:hidden on item wrappers,
  // which clips product detail popovers.
  ::v-deep .vue-recycle-scroller__item-wrapper {
    overflow: visible;
  }

  ::v-deep .vue-recycle-scroller__item-view {
    z-index: 1;
  }

  ::v-deep .product-item.popover-open {
    z-index: 30;
  }
}

.sales-stats {
  flex: 0 1 auto;
  height: 85px;
  border-top: 2px solid var(--card-border);
  padding: 12px 16px;
  position: absolute !important;
  bottom: 0 !important;
  left: 0;
  right: 0;
  background: var(--card-bg);
  backdrop-filter: blur(10px);
  box-shadow: var(--card-shadow);

  .cart-actions {
    .btn {
      border-radius: 10px;
      color: #ffffff;
      font-weight: 700;
      font-size: 14px;
      border: none;
      padding: 12px 16px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      text-transform: uppercase;
      letter-spacing: 0.5px;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
      }
      
      &:active {
        transform: translateY(0);
      }

      &.btn-primary {
        background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
        box-shadow: 0 4px 12px rgba(39, 174, 96, 0.3);
        
        &:hover {
          box-shadow: 0 6px 20px rgba(39, 174, 96, 0.4);
        }
      }

      &.btn-secondary {
        background: linear-gradient(135deg, #7f8c8d 0%, #5d6d7e 100%);
        color: white;
        box-shadow: 0 4px 12px rgba(127, 140, 141, 0.3);
        
        &:hover {
          box-shadow: 0 6px 20px rgba(127, 140, 141, 0.4);
        }
      }

      &.btn-dark {
        background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%);
        box-shadow: 0 4px 12px rgba(52, 73, 94, 0.3);
        
        &:hover {
          box-shadow: 0 6px 20px rgba(52, 73, 94, 0.4);
        }
      }
    }
  }
}

.salesbtn {
  position: absolute !important;
  bottom: 0 !important;
  left: 0;
  right: 0;
  width: 100%;
  padding: 16px 20px;
  background: var(--card-bg);
  border-top: 3px solid rgba(var(--accent-primary-rgb), 0.15);
  backdrop-filter: blur(20px);
  box-shadow: var(--card-shadow-hover);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 10;

    .button-row-top {
      display: flex;
      gap: 8px;
      margin-bottom: 8px;

      .btn {
        flex: 1;
        border-radius: 12px;
        color: #ffffff;
        font-weight: 700;
        border: none;
        padding: 10px 10px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        text-transform: uppercase;

        .button-icon {
          font-size: 16px;
        }

        .shortcut-badge {
          position: absolute;
          bottom: 5px;
          right: 7px;
          background: rgba(0, 0, 0, 0.25);
          color: rgba(255, 255, 255, 0.9);
          font-size: 7px;
          font-weight: 600;
          padding: 1px 4px;
          border-radius: 4px;
          pointer-events: none;
        }
      }

      .cash-button {
        background: #f39c12;
      }

      .card-button {
        background: #27ae60;
      }

      .split-button {
        background: #3498db;
      }

      .kazang-button {
        background: #8e44ad;
      }
    }

    .amount-input-row {
      margin-bottom: 8px;

      .amount-input-group {
        position: relative;

        label {
          display: block;
          margin-bottom: 4px;
          font-size: 12px;
          color: var(--text-secondary);
          font-weight: 700;
        }

        .amount-shortcut {
          position: absolute;
          top: -4px;
          right: 6px;
          font-size: 8px;
          background: rgba(0, 0, 0, 0.22);
          color: rgba(255, 255, 255, 0.9);
          padding: 1px 4px;
          border-radius: 4px;
          pointer-events: none;
        }

        .input-amount {
          width: 100%;
          border-radius: 10px;
          border: 1px solid var(--card-border);
          background: var(--card-bg);
          color: var(--text-primary);
          font-weight: 600;
        }
      }
    }

    .cart-actions {
      display: flex;
      gap: 10px;
      
      .btn {
        flex: 1;
      border-radius: 14px;
      color: #ffffff;
      font-weight: 700;
      font-size: 15px;
      border: none;
      padding: 14px 20px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      text-transform: uppercase;
      letter-spacing: 0.8px;
        position: relative;
        overflow: hidden;

        .shortcut-badge {
          position: absolute;
          bottom: 8px;
          right: 10px;
          background: rgba(0, 0, 0, 0.25);
          color: rgba(255, 255, 255, 0.9);
          font-size: 8px;
          font-weight: 600;
          padding: 2px 5px;
          border-radius: 4px;
          z-index: 4;
          letter-spacing: 0.5px;
          backdrop-filter: blur(4px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
          pointer-events: none;
        }
        
        // Ripple effect
        &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 0;
        height: 0;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.4);
        transform: translate(-50%, -50%);
        transition: width 0.6s, height 0.6s;
      }
      
      &:hover {
        transform: translateY(-3px) scale(1.02);
        
        &::before {
          width: 300px;
          height: 300px;
        }
      }
      
      &:active {
        transform: translateY(-1px) scale(0.98);
      }

      // LOAD button - Blue gradient
      &.btn-secondary:first-child {
        background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
        box-shadow: 0 4px 15px rgba(52, 152, 219, 0.35), 0 2px 4px rgba(52, 152, 219, 0.2);
        
        &:hover {
          background: linear-gradient(135deg, #5dade2 0%, #3498db 100%);
          box-shadow: 0 6px 25px rgba(52, 152, 219, 0.45), 0 4px 8px rgba(52, 152, 219, 0.25);
        }
        
        &:disabled {
          background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%);
          box-shadow: 0 2px 8px rgba(149, 165, 166, 0.2);
          transform: none;
          cursor: not-allowed;
        }
      }

      // SAVE button - Purple gradient
      &.btn-secondary:nth-child(2) {
        background: linear-gradient(135deg, #8e44ad 0%, #71368a 100%);
        box-shadow: 0 4px 15px rgba(142, 68, 173, 0.35), 0 2px 4px rgba(142, 68, 173, 0.2);
        
        &:hover {
          background: linear-gradient(135deg, #a569bd 0%, #8e44ad 100%);
          box-shadow: 0 6px 25px rgba(142, 68, 173, 0.45), 0 4px 8px rgba(142, 68, 173, 0.25);
        }
        
        &:disabled {
          background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%);
          box-shadow: 0 2px 8px rgba(149, 165, 166, 0.2);
          transform: none;
          cursor: not-allowed;
        }
      }

      // DELIVERY button - Teal gradient
      &.btn-dark {
        background: linear-gradient(135deg, #16a085 0%, #138d75 100%);
        box-shadow: 0 4px 15px rgba(22, 160, 133, 0.35), 0 2px 4px rgba(22, 160, 133, 0.2);
        
        &:hover {
          background: linear-gradient(135deg, #1abc9c 0%, #16a085 100%);
          box-shadow: 0 6px 25px rgba(22, 160, 133, 0.45), 0 4px 8px rgba(22, 160, 133, 0.25);
        }
        
        &:disabled {
          background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%);
          box-shadow: 0 2px 8px rgba(149, 165, 166, 0.2);
          transform: none;
          cursor: not-allowed;
        }
      }

      // PAY button - Green gradient (primary action)
      &.btn-primary {
        background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
        box-shadow: 0 4px 15px rgba(39, 174, 96, 0.4), 0 2px 4px rgba(39, 174, 96, 0.25);
        font-size: 16px;
        font-weight: 800;
        
        &:hover {
          background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
          box-shadow: 0 6px 25px rgba(39, 174, 96, 0.5), 0 4px 8px rgba(39, 174, 96, 0.3);
        }
        
        &:disabled {
          background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%);
          box-shadow: 0 2px 8px rgba(149, 165, 166, 0.2);
          transform: none;
          cursor: not-allowed;
        }
      }
    }
  }
}

.scroll-controls {
  position: absolute;
  bottom: 230px;
  right: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 10;

  .scroll-control {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: var(--accent-primary);
    color: var(--accent-primary-contrast);
    border: none;
    box-shadow: 0 4px 12px rgba(var(--accent-primary-rgb), 0.35);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;

    &:hover {
      transform: scale(1.15);
      background: var(--accent-primary-hover, var(--accent-primary));
      box-shadow: 0 6px 24px rgba(var(--accent-primary-rgb), 0.5);
    }

    &:active {
      transform: scale(0.95);
    }
  }
}

// Responsive adjustments
@media (max-width: 1200px) {
  #products-panel .product-grid {
    padding: 12px;
  }

  .scroll-controls {
    .scroll-control {
      width: 56px;
      height: 56px;
      font-size: 20px;
    }
  }
}

@media (max-width: 768px) {
  #products-panel {
    .search-bar {
      padding: 12px;
    }

    .product-grid {
      padding: 10px;
    }
  }

  .salesbtn {
    padding: 10px 12px;

    .button-row-top {
      gap: 6px;

      .btn {
        font-size: 11px;
        padding: 8px 6px;
        gap: 5px;

        .button-icon {
          font-size: 13px;
        }
      }
    }
  }

  .scroll-controls {
    bottom: 190px;

    .scroll-control {
      width: 52px;
      height: 52px;
      font-size: 18px;
    }
  }
}
</style>
